<div class="wrapper">
  <a (click)="deviceSvc_.hamburgerMenu=false"
     [class.active]="active"
     [routerLink]="item.href"
     class="inter large">
    {{ item.label | i18n }}
  </a>
</div>
